import type { Partner } from "@/data/partners";

export function PartnerCard({ partner }: { partner: Partner }) {
  return (
    <div className="flex flex-col rounded-xl border border-border bg-card p-6">
      <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{partner.category}</div>
      <div className="mt-1 font-display text-lg font-bold text-brand">{partner.name}</div>
      <div className="mt-1 text-sm font-medium text-foreground">{partner.tagline}</div>
      <p className="mt-3 flex-1 text-sm text-muted-foreground">{partner.body}</p>
      <a
        href={partner.url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="mt-5 inline-flex w-fit items-center justify-center rounded-lg bg-brand-gold px-6 py-3.5 text-base font-bold text-primary-foreground shadow-md transition-colors hover:bg-brand-gold-hover sm:min-w-[16rem]"
      >
        Visit {partner.name}
      </a>
    </div>
  );
}

export function PartnerCTA({ partner, note }: { partner: Partner; note?: string }) {
  return (
    <div className="mt-8 rounded-xl border border-brand-gold/30 bg-brand-gold/10 p-5 text-sm">
      <strong>{partner.category} partner — {partner.name}:</strong> {note ?? partner.body}
      <div className="mt-5">
        <a
          href={partner.url}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-flex w-full items-center justify-center rounded-lg bg-brand-gold px-6 py-4 text-base font-bold text-primary-foreground shadow-md transition-colors hover:bg-brand-gold-hover sm:w-auto sm:min-w-[16rem]"
        >
          Get started with {partner.name}
        </a>
      </div>
    </div>
  );
}

export function PartnerDisclosure() {
  return (
    <p className="mt-8 text-xs text-muted-foreground">
      Simply Approved Mortgages LLC is a mortgage broker — not a direct lender, law firm, tax advisor, insurance agency, bank, or title company. The partners listed here are independent companies that set their own pricing, terms, and eligibility. We may receive compensation if you open an account or purchase a service through these links, at no additional cost to you. Using a partner is never required to apply for or receive financing with us, and it does not affect your loan terms. Please do your own due diligence and consult your own attorney, accountant, and insurance professional.
    </p>
  );
}
